import "./user-role-skill-match-report.css";

// Short Report: User vs Role Skill Match Index
// const dummyData = {
//   detailedReport: {
//     userDetails: { name: "Daniel Lee" },
//     roleDetails: { name: "Software Engineer" },
//   },
//   skillMatchShortReport: {
//     hardSkillsAligned: ["Java", "Git", "Agile Methodologies"],
//     hardSkillsMissing: ["Python", "Docker", "Microservices"],
//     softSkillsAligned: [
//       "Problem Solving",
//       "Team Collaboration",
//       "Communication",
//     ],
//     softSkillsMissing: ["Adaptability"],
//     hardSkillsAlignmentRating: "Moderate",
//     softSkillsAlignmentRating: "High",
//     overview:
//       "Daniel has moderate skill alignment. He covers 3 of 6 hard skills (50%) and 3 of 4 soft skills (75%). Strong in teamwork and communication, he can integrate well into collaborative tasks now. However, gaps in modern backend/cloud technologies (Python, Docker, Microservices) and adaptability may limit flexibility. Training in these areas would raise his technical and behavioral readiness.",
//   },
// };

const UserRoleSkillMatchReport = (props) => {
  console.log("UserRoleSkillMatchReport props:", props);
  const comparisonResult = props?.comparisonData.skillMatchShortReport;

  const userName = comparisonResult?.userName || "";
  const roleName = comparisonResult?.roleName || "";

  const hardSkillsAligned = comparisonResult.hardSkillsAlignment.aligned || [];
  const hardSkillsMissing = comparisonResult.hardSkillsAlignment.missing || [];
  const softSkillsAligned = comparisonResult.softSkillsAlignment.aligned || [];
  const softSkillsMissing = comparisonResult.softSkillsAlignment.missing || [];

  const hardSkillsAlignmentRating =
    comparisonResult.skillMatchPercentage.hardSkillsMatchPercentage;
  const softSkillsAlignmentRating =
    comparisonResult.skillMatchPercentage.softSkillsMatchPercentage;

  const hardSkillsMatchPercentage =
    hardSkillsAligned.length > 0
      ? Math.round(
          (hardSkillsAligned.length /
            (hardSkillsAligned.length + hardSkillsMissing.length)) *
            100
        )
      : 0;
  const softSkillsMatchPercentage =
    softSkillsAligned.length > 0
      ? Math.round(
          (softSkillsAligned.length /
            (softSkillsAligned.length + softSkillsMissing.length)) *
            100
        )
      : 0;

  const clamp = (v) => Math.max(0, Math.min(100, Number.isFinite(v) ? v : 0));

  return (
    <div className="ur-sm-short-report-container">
      <div className="ur-sm-report-header">
        <h3>Skill Match Index</h3>
        <p>Assessment of skill alignment between user and role requirements</p>
      </div>

      <div className="ur-sm-comparison-summary">
        <div className="ur-sm-summary-card">
          <div className="ur-sm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
              <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
            </svg>
          </div>
          <div className="ur-sm-summary-content">
            <div className="ur-sm-summary-value">{roleName}</div>
            <div className="ur-sm-summary-label">Target Role</div>
          </div>
        </div>

        <div className="ur-sm-summary-card">
          <div className="ur-sm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div className="ur-sm-summary-content">
            <div className="ur-sm-summary-value">{userName}</div>
            <div className="ur-sm-summary-label">User Profile</div>
          </div>
        </div>

        <div className="ur-sm-summary-card">
          <div className="ur-sm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="ur-sm-summary-content">
            <div className="ur-sm-summary-value">
              {hardSkillsMissing.length}
            </div>
            <div className="ur-sm-summary-label">Missing Hard Skills</div>
          </div>
        </div>

        <div className="ur-sm-summary-card">
          <div className="ur-sm-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="ur-sm-summary-content">
            <div className="ur-sm-summary-value">
              {softSkillsMissing.length}
            </div>
            <div className="ur-sm-summary-label">Missing Soft Skills</div>
          </div>
        </div>
      </div>

      {/* Skills Comparison */}
      <div className="ur-sm-metrics-comparison">
        <h3>Hard Skills Alignment</h3>
        <div className="ur-sm-skills-pills">
          <div className="ur-sm-skills-section">
            <span className="ur-sm-skills-label">Aligned:</span>
            <div className="ur-sm-pills-container">
              {hardSkillsAligned.length === 0 && (
                <span className="ur-sm-no-skills">No aligned hard skills</span>
              )}
              {hardSkillsAligned.map((skill, index) => (
                <span key={index} className="ur-sm-pill ur-sm-pill-aligned">
                  {skill}
                </span>
              ))}
            </div>
          </div>
          <div className="ur-sm-skills-section">
            <span className="ur-sm-skills-label">Missing:</span>
            <div className="ur-sm-pills-container">
              {hardSkillsMissing.length === 0 && (
                <span className="ur-sm-no-skills">No missing hard skills</span>
              )}
              {hardSkillsMissing.map((skill, index) => (
                <span key={index} className="ur-sm-pill ur-sm-pill-missing">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        <h3 style={{ marginTop: "24px" }}>Soft Skills Alignment</h3>
        <div className="ur-sm-skills-pills">
          <div className="ur-sm-skills-section">
            <span className="ur-sm-skills-label">Aligned:</span>
            <div className="ur-sm-pills-container">
              {softSkillsAligned.length === 0 && (
                <span className="ur-sm-no-skills">No aligned soft skills</span>
              )}
              {softSkillsAligned.map((skill, index) => (
                <span key={index} className="ur-sm-pill ur-sm-pill-aligned">
                  {skill}
                </span>
              ))}
            </div>
          </div>
          <div className="ur-sm-skills-section">
            <span className="ur-sm-skills-label">Missing:</span>
            <div className="ur-sm-pills-container">
              {softSkillsMissing.length === 0 && (
                <span className="ur-sm-no-skills">No missing soft skills</span>
              )}
              {softSkillsMissing.map((skill, index) => (
                <span key={index} className="ur-sm-pill ur-sm-pill-missing">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        <h3 style={{ marginTop: "24px" }}>Skills Match Percentage</h3>
        <div className="ur-sm-metrics-chart">
          <div className="ur-sm-metric-bar-container">
            <div className="ur-sm-metric-info">
              <span className="ur-sm-metric-name">Hard Skills Match</span>
            </div>
            <div className="ur-sm-metric-bar">
              <div
                className="ur-sm-metric-fill"
                style={{ width: `${clamp(hardSkillsMatchPercentage)}%` }}
              />
              <span className="ur-sm-metric-value">{`${hardSkillsMatchPercentage}%`}</span>
            </div>
          </div>

          <div className="ur-sm-metric-bar-container">
            <div className="ur-sm-metric-info">
              <span className="ur-sm-metric-name">Soft Skills Match</span>
            </div>
            <div className="ur-sm-metric-bar">
              <div
                className="ur-sm-metric-fill"
                style={{ width: `${clamp(softSkillsMatchPercentage)}%` }}
              />
              <span className="ur-sm-metric-value">{`${softSkillsMatchPercentage}%`}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="ur-sm-insights-section">
        <h3>Analysis Overview</h3>
        <div className="ur-sm-analysis-paragraph">
          <p>{props.comparisonData.skillMatchShortReport.overview} </p>
        </div>
      </div>
    </div>
  );
};

export default UserRoleSkillMatchReport;
